export default __webpack_public_path__ + "static/NeueMontreal-Regular-69741ac8785c075bfbf3ddd3363d7831.woff2";